<template>
  <div class="one-signal">
    <div class="one-signal__overlay"></div>

    <div class="one-signal__modal">
      <div class="header">
        <button class="btn btn--gray" @click="$emit('close-modal')">X</button>
      </div>

      <div class="content-modal">

      

        <custom-form :handle-submit="handleSubmitNotification" >
          <text-field
            v-model="notification.data.message"
            label="Message" 
            name="message" 
            v-validate="'required'"
            data-vv-value-path="input"
            data-vv-name="message"
            error-message="Fill in the message"
            :has-error=" errors.has('message')"
            :required="true"/>
          
          <div class="error_message" v-if="showError">
            <span>{{errorMessage}}</span>
          </div>

          <button type="submit" class="btn btn--primary btn--block" :disabled="notification.loading">
            {{ notification.loading ? 'Sending...' : 'Send notification' }}
          </button>
        </custom-form>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import RunnerService from '@/services/runnersByRace'
import CustomForm from '@/components/Forms/Form'
import TextField from '@/components/Forms/TextField'
import _ from 'lodash'
import {Config} from '../config'

export default {
  name: 'ModalOneSignal',
  data: () => ({
    notification: {
      data: {
        message: ''
      },
      loading: false
    },
    errorMessage:'',
    showError:false
  }),
  props: ['raceId'],
  methods: {
    async handleSubmitNotification () {
      const isValid = await this.$validator.validateAll()
      this.errorMessage = ''
      this.showError=false

      if (isValid) {
        this.notification.loading = true

        let { data: runners } = await RunnerService.getAll(this.raceId)

        const filters = runners.reduce((filters, runner, index) => {
          if (index === 0) {
            filters.push({ field: 'tag', key: 'runnerId', relation: '=', value: runner.id })
          } else {
            filters.push({ operator: 'OR' })
            filters.push({ field: 'tag', key: 'runnerId', relation: '=', value: runner.id })
          }
          return filters
        }, [])
 
        //If filter length is greater than 200 then divide array in group of 200 array
        //Fix for - https://app.asana.com/0/1137425856170315/1200122016958600
        let  filterGroup = []
        if(filters!=undefined && filters.length > Config.ONESIGNAL_GROUP){          
          filterGroup = _.chunk(filters, Config.ONESIGNAL_GROUP)
        }else{
          filterGroup.push(filters)
        }
        axios.defaults.headers.common['Authorization'] = Config.ONESIGNAL_Authorization

        try{
            console.log("filterGroup---",filterGroup)
            let requests = filterGroup.map(async (filter) => {
              return new Promise(async(resolve) => {
                try{
                    await axios.post(Config.ONESIGNAL_API_URL, {
                      app_id: Config.ONESIGNAL_APP_ID,
                      filters:filter,
                      contents: {
                        ja: this.notification.data.message,
                        en: this.notification.data.message
                      }
                    })
                    resolve()
                }catch(error){
                    const { response } = error
                    const { request, ...errorObject } = response // take everything but 'request'
                    if (
                      errorObject.data != undefined &&
                      errorObject.data.errors != undefined &&
                      errorObject.data.errors[0] != undefined
                    ) {
                      this.notification.loading = false
                      this.errorMessage = errorObject.data.errors[0]
                      this.showError=true
                    }
                  }          
              })
            })

            Promise.all(requests).then(() =>{
              this.notification.data.message = ''
              this.notification.loading = false
              this.$emit('close-modal')
            })
          }catch(error){
              this.notification.loading = false
              this.errorMessage = "Some error occured while sending notification."
              this.showError=true        
          }

        // await axios.post('https://onesignal.com/api/v1/notifications', {
        //   app_id: 'c15304d8-dd12-4311-ba18-761182661338',
        //   filters,
        //   contents: {
        //     ja: this.notification.data.message,
        //     en: this.notification.data.message
        //   }
        // })

        // this.notification.data.message = ''
        // this.notification.loading = false
        // this.$emit('close-modal')

       
      }
    },
    closeModalNotification () {
      this.notification.data.message = ''
      this.notification.loading = false
      this.$emit('close-modal')
    }
  },
  components: {
    CustomForm,
    TextField
  }
}
</script>

<style lang="stylus" scoped>
  .error_message
    color red

  .one-signal
    &__overlay
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      background rgba(#000, 0.45)
      z-index 80000

    &__modal
      position fixed
      top 50%
      left 50%
      padding 30px
      transform translateX(-50%) translateY(-50%)
      width 500px
      z-index 90000
      background #ffffff
      border-radius 3px

      .header
        text-align right


</style>




// WEBPACK FOOTER //
// ModalOneSignal.vue?64cff2bd